const transformTitleToSnakeCase = (title) => title
    .split(' ')
    .map((word) => word.toLowerCase())
    .join('_');

export default transformTitleToSnakeCase;